export default "__VITE_ASSET__Brn_OMRq__"